export default __webpack_public_path__ + "images/EX.5650489.png";